define('infoArchitecture/contentManagementRoutes',[
    'services/navHelper'
], function (navHelper) {

    'use strict';

    /**
     * TRT - 4-10-2015 - Check with CM team before removing this file.
     *
     * Content Management has been pulled out into the a feature component.
     *
     * CM routes in Directory and Admin-UI currently reference #content and #admin/content, however
     * the feature component routes are #contentManagement.
     *
     * Leaving these redirects in temporarily to eliminate the need for deployment coordination between
     * Directory, Admin-UI, and Content Management feature component.
     *
     * I'll remove this file once those applications have updated their CM routes and those changes
     * have been propagated through production.
     *
     */
    return {
        //Admin Routes

        '#admin/content': {
            handler: function () {
                navHelper.redirectTo('contentManagement/admin/workspaces');
            }
        },

        '#admin/content/auditSearch': {
            handler: function () {
                navHelper.redirectTo('contentManagement/admin/auditSearch');
            }
        },

        '#admin/content/workspaces': {
            handler: function () {
                navHelper.redirectTo('contentManagement/admin/workspaces');
            }
        },

        '#content/dashboard': {
            handler: function () {
                navHelper.redirectTo('contentManagement/dashboard');
            }
        }
    };
});

